import React from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/places/Reveal";
import AnimatedBlob from "@/components/places/AnimatedBlob";
import SEO from "@/components/places/SEO";
import Timeline38 from "@/components/places/Timeline38";
import { useContent } from "@/lib/content";

/**
 * Dedicated page for the "38 Anos" vertical timeline.
 * Accessible via the italic serif "38 anos" link in the header (after Contato).
 */
export default function Timeline38Page() {
  const { timeline_38: t38 = {} } = useContent();
  return (
    <>
      <SEO
        title={`${t38.title || "38 anos"} · Places`}
        description={t38.subtitle || "Uma linha do tempo de projetos, pessoas e propósito. 38 anos construindo o futuro do marketing imobiliário."}
        breadcrumbs={[
          { name: "Home", url: typeof window !== "undefined" ? window.location.origin + "/" : "/" },
          { name: "38 anos", url: typeof window !== "undefined" ? window.location.href : "/38-anos" },
        ]}
      />

      <section className="theme-light pt-36 md:pt-44 pb-16 grain relative overflow-hidden" data-testid="timeline38-hero">
        <AnimatedBlob className="bg-accent-orange top-10 right-0 w-[500px] h-[500px] opacity-20" />
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
          <Reveal>
            <div className="text-xs uppercase tracking-widest text-accent-orange mb-4">{t38.eyebrow || "Linha do tempo"}</div>
            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] max-w-5xl">
              <span className="font-serif-italic block text-4xl md:text-5xl lg:text-6xl text-accent-orange mb-8 md:mb-12">38 anos</span>
              {t38.title || "construindo o futuro do marketing imobiliário."}
            </h1>
            {t38.subtitle && <p className="mt-8 max-w-2xl text-base md:text-lg text-neutral-700 leading-relaxed">{t38.subtitle}</p>}
          </Reveal>
        </div>
      </section>

      <Timeline38 hideTitle />

      <section className="theme-dark py-24 text-center border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <Reveal>
            <div className="font-display text-4xl md:text-6xl mb-8 leading-tight">
              Vamos escrever <span className="font-serif-italic text-accent-yellow">o próximo capítulo</span> juntos?
            </div>
            <div className="flex flex-wrap justify-center gap-3">
              <Link to="/contato?intent=client" className="bg-accent-yellow text-black btn-sharp rounded-full hover:bg-white transition-colors" data-testid="timeline38-cta-client">Quero ser cliente</Link>
              <Link to="/sobre" className="border border-white/30 btn-sharp rounded-full hover:bg-white hover:text-black transition-colors">Nossa história</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
